import { Box, ListItem } from '@mui/material';
import { FC, MouseEvent } from 'react';
import { sideNavOptionBorderStyle } from '../common';
import { SideNavOptions } from '../types';
import fallbackIcon from '../../../assets/icons/module_fallback_icon.png';

type ManageUsersNavItemProps = {
  option: SideNavOptions;
  isActive: boolean;
  isCollapsed?: boolean;
  onClick: (event: MouseEvent<HTMLElement>) => void;
};

const ManageUsersNavItem: FC<ManageUsersNavItemProps> = ({
  option,
  isActive,
  isCollapsed = false,
  onClick,
}) => {
  const href = option.subOptions?.length === 1 ? option.subOptions[0].path : undefined;

  return (
    <ListItem
      button
      {...(href ? { component: 'a', href, rel: 'noopener noreferrer' } : { component: 'div' })}
      onClick={onClick}
      sx={{
        '&:hover': {
          backgroundColor: '#2F736E1F',
        },
        backgroundColor: isActive ? '#2F736E1F' : 'inherit',
        color: '#F6F8F9',
        borderRadius: isCollapsed ? '8px' : '24px',
        display: 'flex',
        alignItems: 'center',
        padding: '0.75rem 0.5rem',
        my: isCollapsed ? '0.5rem' : 0,
        overflow: 'hidden',
        ...(isActive && {
          '&::after': sideNavOptionBorderStyle,
        }),
      }}
    >
      {isCollapsed ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            lineHeight: '1.25rem',
            fontSize: '0.625rem',
            fontWeight: 700,
            alignItems: 'center',
            width: '100%',
          }}
        >
          <img
            src={(option.icon as string) || fallbackIcon}
            alt="module-icon"
            style={{ width: '22px', height: '22px' }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            gap: '12px',
            alignItems: 'center',
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: '#F6F8F9',
          }}
        >
          <img
            src={(option.icon as string) || fallbackIcon}
            alt="module-icon"
            style={{ width: '22px', height: '22px' }}
          />
          {option.label}
        </Box>
      )}
    </ListItem>
  );
};

export default ManageUsersNavItem;
